import { useEffect, useRef, useState } from 'react';
import { navLinks } from '@/mocks/content';

export default function Header() {
  const [open, setOpen] = useState(false);
  const panelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') setOpen(false); };
    const onClick = (e: MouseEvent) => {
      if (panelRef.current && !panelRef.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('keydown', onKey);
    document.addEventListener('mousedown', onClick);
    return () => {
      document.removeEventListener('keydown', onKey);
      document.removeEventListener('mousedown', onClick);
    };
  }, [open]);

  return (
    <header className="sticky top-0 z-50 bg-white border-b rule">
      <div ref={panelRef} className="relative">
        <div className="px-cell h-16 grid grid-cols-[auto_1fr] lg:grid-cols-2 items-center">
          <div className="flex items-center gap-6">
            <a href="#top" className="flex items-center gap-2.5 cursor-pointer" aria-label="RADIUS home">
              <span className="font-heading font-medium tracking-[-0.02em] text-[16px]">RADIUS</span>
            </a>
            <span className="hidden xl:inline t-label text-foreground-600">Local growth, made visible</span>
          </div>
          <nav className="justify-self-end hidden md:flex items-center gap-8" aria-label="Primary">
            {navLinks.slice(0, 3).map((l) => (
              <a key={l.href} href={l.href} className="group relative text-[14px] text-foreground-700 hover:text-foreground-950 cursor-pointer whitespace-nowrap py-2">
                {l.label}
                <span className="absolute left-0 bottom-0.5 h-[2px] w-0 bg-accent-600 transition-all duration-300 group-hover:w-full" />
              </a>
            ))}
            <a href="#contact" className="inline-flex items-center gap-2 py-2 text-[14px] text-foreground-950 hover:text-accent-600 transition-colors duration-200 cursor-pointer whitespace-nowrap">
              Contact <span aria-hidden="true">↗</span>
            </a>
          </nav>
          <button
            type="button"
            className="md:hidden justify-self-end w-11 h-11 -mr-2 flex items-center justify-center cursor-pointer"
            aria-expanded={open}
            aria-controls="mobile-menu"
            aria-label={open ? 'Close menu' : 'Open menu'}
            onClick={() => setOpen((v) => !v)}
          >
            <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-xl`} />
          </button>
        </div>
        {open && (
          <nav id="mobile-menu" className="md:hidden absolute top-full left-0 right-0 bg-background-50 border-b rule" aria-label="Mobile">
            <div className="px-cell py-2">
              {navLinks.map((l, i) => (
                <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="flex items-center justify-between h-14 border-b rule last:border-b-0 text-[16px] cursor-pointer">
                  <span>{l.label}</span>
                  <span className="t-label text-foreground-600">0{i + 1}</span>
                </a>
              ))}
            </div>
          </nav>
        )}
      </div>
    </header>
  );
}